import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  RFQ_LINEITEM_CLASS,
  RFQ_REQUEST_CLASS,
  RFQ_RESPONSE_CLASS} from '../../data/RFQClassDefinitionsConstants'
import { RFXRequest } from '../../interfaces/RFXBackendModel';
import { RootState } from '../../store';

export interface RFXRequestBackendModelState {
  currentRFXReqBackendModel: RFXRequest
}

const initialState: RFXRequestBackendModelState = {
  currentRFXReqBackendModel: {
    rfxRequestRevisionedId: {
      id: {
        value: ''
      },
      revision: 0
    },
    rfxRequestVersion: 0,
    rfxRequestClassId: {
      value: RFQ_REQUEST_CLASS
    },
    rfxResponseClassId: {
      value: RFQ_RESPONSE_CLASS
    },
    rfxLineItemClassId: {
      value: RFQ_LINEITEM_CLASS
    },
    region: {
      value: ''
    },
    beginAt: 0,
    dueAt: 0,
    name: '',
    type: '',
    buyer: {
      value: ''
    },
    currency: '',
    suppliers: [],
    documents: [],

    lifeCycle: {
      lifeCycleGraphId: 'DEFAULT_AWS_RFQ_REQUEST',
      lifeCycleState: {
        name: 'Draft',
        version: 1
      },
      lifeCycleVersion: 1
    }
  }
}

const rfxRequestBackendModelSlice = createSlice({
  name: 'rfxRequestBackendModel',
  initialState,
  reducers: {
    setCurrentRFXReqBackendModel(state, action) {
      state.currentRFXReqBackendModel = action.payload;
    }
  }
});

export const {
  setCurrentRFXReqBackendModel
} = rfxRequestBackendModelSlice.actions;

export const selectCurrentRFXReqBackendModel = (state: RootState): RFXRequest =>
  state.rfxRequestBackendModel.currentRFXReqBackendModel;

export default rfxRequestBackendModelSlice.reducer;
